import React from 'react'
import PropTypes from 'prop-types';
import _ from 'underscore';
// AppActions, App Actions, app-actions, appActions

// NOSONAR: `category` and `label` are Blockly toolbox-XML pseudo-elements,
// not real DOM elements. Attributes like `iconclass` and `text` are valid
// Blockly toolbox attributes.
const AppActions = ({ blocks, context }) => {
    const childBlocks = _.map(blocks, ({ component: BlockComponent }, blockKey) => (
        <BlockComponent context={context} key={blockKey}/>
    ));

    if (childBlocks.length > 0) {
        return (
            <category name='App Actions' id='appActions' iconclass='category with-icon-paths snap-icon-app_action_dual'>{/* NOSONAR */}
                <label text="App Actions"/>{/* NOSONAR */}
                { childBlocks }
            </category>
        );
    }

    return null;
};

AppActions.propTypes = {
    blocks: PropTypes.object.isRequired,
    context: PropTypes.object.isRequired,
};

export default AppActions;